define('../app/fukit/view/block/loading.dimmer.view',['require','exports','module','underscore','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _     = require('underscore'),
      UIKit = require('uikit/uikit');

  var LoadingDimmerView = UIKit.Dimmer2.extend({
    options: _.extend({}, UIKit.Dimmer2.prototype.options, {
      inverted: true,
      page: true,
    }),

    content: {
      type: null,
    },
  });

  module.exports = LoadingDimmerView;
});

